export function getTotalDaysDifference(startDate, endDate) {
    var date1 = new Date(startDate)
    var date2 = new Date(endDate)
    var timeDiff = Math.abs(date2.getTime() - date1.getTime())
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    return diffDays
}